import { render, staticRenderFns } from "./OpenAISetting.vue?vue&type=template&id=7dfe5662&"
import script from "./OpenAISetting.vue?vue&type=script&lang=ts&"
export * from "./OpenAISetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports